import React, { useMemo, useState, useRef, useEffect, useContext } from 'react';
import { Portal, svgSprite, Tooltip } from '../../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import PropTypes from 'prop-types';
import css from './Buttons.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import Actions from '../Actions/Actions';
import { UserProfileContext } from '../../../../common/utils/getContext';
import { generateUniqueId } from '../../../../common/utils/utils';

const WrapperButton = (props) => {
    const ref = useRef();
    const ref2 = useRef();
    const isMobile = useWindowDimensions() < 768;

    useEffect(() => {
        const elem = ref?.current;
        if (elem) {
            const listener = (e) => {
                e.preventDefault();
                if (props.onRightClick) {
                    props.onRightClick();
                }
            };
            if (elem) {
                elem.oncontextmenu = listener;
            }
            return () => {
                elem.removeEventListener('contextmenu', listener);
            };
        }
    }, [ref.current, props.onRightClick]);

    useEffect(() => {
        const elem = ref2?.current;
        if (elem) {
            const listener = (e) => {
                e.preventDefault();
                if (props.onRightClick) {
                    props.onRightClick();
                }
            };
            if (elem) {
                elem.oncontextmenu = listener;
            }
            return () => {
                elem.removeEventListener('contextmenu', listener);
            };
        }
    }, [ref2.current, props.onRightClick]);

    if (props.hint) {
        return (
            <div ref={ref} {...props}>
                <Tooltip
                    text={props.hint}
                    compStyle={{
                        inner: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }}
                    showModalTooltip={!isMobile}
                >
                    {props.children}
                </Tooltip>
            </div>
        );
    }
    return (
        <div ref={ref2} {...props}>
            {props.children}
        </div>
    );
};
const Buttons = ({
    tbodyRowIndexDel,
    getHandlers,
    val,
    gridStyles,
    name,
    refTable,
    refTableChild,
    gridName,
    translation,
    isFixedLastColumnShow
}) => {
    const { stylers, classes, existCl, existSt } = generateGridStyles(gridStyles, name);
    const { officePage } = useContext(UserProfileContext) || {};
    const ref = useRef(false);
    const handlers = getHandlers();
    const [showModal, setShowModal] = useState(false);
    const widthDimensions = useWindowDimensions();
    const mobile = useMemo(() => widthDimensions < 768, [widthDimensions]);
    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (showModal && ref.current && !ref.current.contains(e.target)) {
                setShowModal(false);
            }
        };
        document.addEventListener('click', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [showModal]);
    const isAdminFinanse = val.hasOwnProperty('data') && val?.data?.hasOwnProperty('post') && val?.data?.hasOwnProperty('reject');

    if (isAdminFinanse && isFixedLastColumnShow) {
        return (
            <Actions
                getHandlers={getHandlers}
                val={val}
                refTable={refTable}
                refTableChild={refTableChild}
                gridName={gridName}
                translation={translation}
                gridStyles={gridStyles}
                name={name}
                isFixedLastColumnShow={isFixedLastColumnShow}
            />
        );
    }

    return (
        <div
            ref={ref}
            style={stylers.wrapper}
            className={existCl('wrapper') || classnames(css.flexRow, css.alignItemsCenter, css.justifyContentCenter)}
        >
            {handlers?.createId && (
                <div
                    {...getHandlers('createId')}
                    className={classnames(existCl('destroyIcoWrap') || css.tableButton, existCl('tableButton'))}
                >
                    {svgSprite('folder-plus', {
                        className: existCl('destroyIco') || classnames(css.tableButtonIcon, css.tableButtonIconNew),
                        style: stylers.destroyIco
                    })}
                </div>
            )}
            {val.comment && (
                <>
                    {isFixedLastColumnShow && !gridName.endsWith('-last') ? null : mobile ? (
                        val.comment.modal && val.comment.modal.show ? (
                            <Portal closeHandler={val.comment.closeModal}>
                                <val.commentModal val={val} refTableChild={refTableChild} />
                            </Portal>
                        ) : null
                    ) : (
                        <>
                            <val.commentModal val={val} refTableChild={refTableChild} />
                        </>
                    )}
                    <div
                        {...getHandlers('comment')}
                        style={stylers.updateIcoWrap}
                        className={classnames(existCl('updateIcoWrap') || css.tableButton, existCl('tableButton'))}
                    >
                        {val.comment.hint ? (
                            <Tooltip
                                text={val.comment.hint}
                                compStyle={{
                                    inner: {
                                        display: 'flex',
                                        alignItems: 'center'
                                    }
                                }}
                            >
                                {svgSprite(!val?.comment?.value ? 'comment-add' : 'comment-lines', {
                                    className: existCl('updateIco') || css.tableButtonIcon,
                                    style: existSt('updateIco') || {
                                        fill: !val?.comment?.value
                                            ? ['var(--greyExtraDarkColor)', 'var(--blueColor])']
                                            : 'var(--blueColor)'
                                    }
                                })}
                            </Tooltip>
                        ) : (
                            svgSprite(!val?.comment?.value ? 'comment-add' : 'comment-lines', {
                                className: existCl('updateIco') || css.tableButtonIcon,
                                style: existSt('updateIco') || {
                                    fill: !val?.comment?.value
                                        ? ['var(--greyExtraDarkColor)', 'var(--blueColor])']
                                        : 'var(--blueColor)'
                                }
                            })
                        )}
                    </div>
                </>
            )}
            {val.view && (
                <WrapperButton
                    {...getHandlers('view')}
                    style={stylers.updateIcoWrap}
                    className={classnames(existCl('updateIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.view.hint || false}
                >
                    {svgSprite(val.view.active ? 'eye-slash' : 'eye', {
                        style: stylers.updateIco,
                        className: existCl('updateIco') || css.tableButtonIcon
                    })}
                </WrapperButton>
            )}

            {val.detail && (
                <WrapperButton
                    {...getHandlers('detail')}
                    style={stylers.updateIcoWrap}
                    className={classnames(existCl('updateIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.detail.hint || false}
                >
                    {svgSprite(val.detail.active ? 'eye-slash' : 'eye', {
                        style: stylers.updateIco,
                        className: existCl('updateIco') || css.tableButtonIcon
                    })}
                </WrapperButton>
            )}
            {val.update && (
                <WrapperButton
                    {...getHandlers('update')}
                    className={classnames(existCl('updateIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.update.hint || false}
                    key={generateUniqueId()}
                >
                    {svgSprite(val.updateIcon || 'pen-field', {
                        style: stylers.updateIco,
                        className: existCl('updateIco') || css.tableButtonIcon
                    })}
                </WrapperButton>
            )}
            {val?.destroy && (
                <WrapperButton
                    {...getHandlers('destroy')}
                    style={stylers.destroyIcoWrap}
                    className={classnames(existCl('destroyIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.destroy.hint || false}
                >
                    {svgSprite(officePage ? 'trash-gt' : 'trash', {
                        style: stylers.destroyIco,
                        className: existCl('destroyIco') || classnames(css.tableButtonIcon, css.tableButtonIconDelete)
                    })}
                </WrapperButton>
            )}
            {val?.block && (
                <WrapperButton
                    {...getHandlers('block')}
                    style={stylers.destroyIcoWrap}
                    className={classnames(existCl('destroyIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.block.hint || false}
                >
                    {svgSprite('lock', {
                        style: stylers.destroyIco,
                        className: existCl('destroyIco') || classnames(css.tableButtonIcon, css.tableButtonIconDelete)
                    })}
                </WrapperButton>
            )}
            {val?.print && (
                <WrapperButton
                    {...getHandlers('print')}
                    style={stylers.destroyIcoWrap}
                    className={classnames(existCl('destroyIcoWrap') || css.tableButton, existCl('tableButton'))}
                    hint={val.print.hint || false}
                >
                    {svgSprite('print', {
                        style: stylers.printIco,
                        className: existCl('printIco') || classnames(css.tableButtonIcon, css.tableButtonIconDelete)
                    })}
                </WrapperButton>
            )}
            {val.data && Object.keys(val.data).length
                ? Object.keys(val.data).map((key) => {
                      if (val?.data?.[key]?.myComponent) return val.data[key].myComponent;
                      return (
                          <WrapperButton
                              {...getHandlers(key)}
                              key={`${tbodyRowIndexDel}${key}`}
                              style={{
                                  ...(stylers.updateIcoWrap || {}),
                                  ...(stylers[key] || {}),
                                  ...(val.data[key]?.variation ? stylers[`${key}_${val.data[key]?.variation}`] : {})
                              }}
                              className={classnames(
                                  existCl('updateIcoWrap') || css.tableButton,
                                  existCl('tableButton'),
                                  classes[key],
                                  val.data[key]?.variation ? classes?.[key]?.[val.data[key]?.variation] : null
                              )}
                              hint={val.data[key].hint || false}
                          >
                              {val.data[key].icon
                                  ? svgSprite(val.data[key].icon, {
                                        style: {
                                            ...stylers[`${key}_iconStyles`],
                                            ...(val.data[key]?.variation
                                                ? stylers[`${key}_${val.data[key]?.variation}_iconStyles`]
                                                : {})
                                        },
                                        className: classnames(
                                            css.tableButtonIcon,
                                            classes[`${key}_iconStyles`],
                                            val.data[key]?.variation
                                                ? classes[`${key}_${val.data[key]?.variation}_iconStyles`]
                                                : ''
                                        )
                                    })
                                  : null}
                          </WrapperButton>
                      );
                  })
                : null}
        </div>
    );
};
Buttons.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    styles: PropTypes.object,
    name: PropTypes.string
};
export default Buttons;
